import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { lizardDateSchema } from "../dates";
import { paginatedSchema } from "../pagination";

import { organisationSchema } from "./organisations";

/* The list view of this endpoint only shows invitations with status "pending".

   Moreover it is unclear who is allowed to see details of invitiations, I get
   404s on invitation URLs I do get in the list view. Not sure if anything
   besides the list view is needed, so ignoring that for now.
 */

export const invitationSchema = z.object({
  id: z.number(),
  url: z.string(),
  status: z.string(),
  user: z.string().nullable() /* Not sure if username or URL */,
  email: z.string(),
  created_at: lizardDateSchema.nullable(),
  email_sent_at: lizardDateSchema.nullable(),
  last_modified: lizardDateSchema.nullable(),
  created_by: z.string().nullable() /* URL to user */,
  permissions: z.array(
    z.object({
      organisation: organisationSchema,
      roles: z.array(
        z.union([
          z.literal("user"),
          z.literal("supplier"),
          z.literal("admin"),
          z.literal("manager"),
        ])
      ),
    })
  ),
});

export type Invitation = z.infer<typeof invitationSchema>;

export const invitationListSchema = paginatedSchema(invitationSchema);
export type InvitationList = z.infer<typeof invitationListSchema>;

export function useInvitations(params = {}) {
  const url = combineUrlAndParams("/api/v4/invitations/", params);
  return useParsedQuery(
    ["lizard-api-v4", "invitations", url],
    () => fetchWithError(url),
    (json: unknown) => invitationListSchema.parse(json)
  );
}
